// @flow
import React from 'react';
import { DayOfWeekType } from 'common/enums/DateTimeEnums';
import { WeekEnum } from 'common/enums/WeekEnums';
import { ButtonWithPopover, ButtonTypes } from 'common/components/core/button';
import { Holiday } from 'common/models/internal/MasterOutlet';
import { Flex, Text } from '@locus-taxy/neo-ui';
import theme from './HolidaySelector.scss';
import classnames from 'classnames';
import _ from 'lodash';

type Props = {
    onChange: Function,
    t: Function,
    disableClick?: boolean,
    holidays: Array<Object>,
    onHolidayChange: Function
};

type HolidayWeekProps = {
    t: Function,
    toggleDay: Function,
    disableClick: Function,
    week: Object,
    weekInfo: Object
};

class HolidayWeek extends React.PureComponent<HolidayWeekProps> {
    onClick = (day: string) => {
        const { week, toggleDay } = this.props;

        toggleDay && toggleDay(week, day);
    };

    isDaySelected = (day: string) => {
        const { weekInfo } = this.props;
        return weekInfo.days.indexOf(day) >= 0;
    };

    render() {
        const { t, disableClick } = this.props;
        return (
            <>
                {_.map(DayOfWeekType, label => {
                    return (
                        <ButtonWithPopover
                            circle
                            disableClick={!!disableClick}
                            ripple={false}
                            buttonType={ButtonTypes.Text}
                            label={t(`daysShortCode.${label}`)}
                            fieldId={label}
                            key={label}
                            onClick={this.onClick}
                            theme={theme}
                            className={classnames(theme.button, {
                                [theme.clicked]: this.isDaySelected(label)
                            })}
                        />
                    );
                })}
            </>
        );
    }
}

export default class HolidaySelector extends React.PureComponent<Props> {
    toggleDay = (week: string, toggledDay: string) => {
        const { onChange } = this.props;
        let updatedHolidays = this.getHolidays();
        updatedHolidays = updatedHolidays.map(weekInfo => {
            let updatedWeekInfo = weekInfo;
            if (weekInfo.week === week) {
                let { days: updatedDays } = weekInfo;

                const dayIndex = weekInfo.days.indexOf(toggledDay);
                if (dayIndex === -1) {
                    updatedDays = [...updatedDays, toggledDay];
                } else {
                    updatedDays = weekInfo.days.filter(
                        day => day !== toggledDay
                    );
                }
                updatedWeekInfo = Holiday.fromJS({
                    week: weekInfo.week,
                    days: updatedDays
                });
            }
            return updatedWeekInfo;
        });
        updatedHolidays = updatedHolidays.filter(
            weekInfo => weekInfo.days.size
        );
        onChange?.(updatedHolidays);
    };

    getHolidays = () => {
        return Object.keys(WeekEnum).map(week => {
            return this.getCurrentWeekInfo(week);
        });
    };

    getCurrentWeekInfo = (week: string) => {
        const { holidays } = this.props;
        const selectedweek = holidays.find(weekInfo => weekInfo.week === week);
        return (
            selectedweek ||
            Holiday.fromJS({
                week,
                days: []
            })
        );
    };

    render() {
        const { holidays, t } = this.props;
        if (holidays) {
            return (
                <Flex flexDirection={Flex.Direction.Column}>
                    {Object.keys(WeekEnum).map(week => {
                        return (
                            <Flex
                                key={week}
                                className={theme.dayWeekSelector}
                                flexDirection={Flex.Direction.Row}
                            >
                                <Text className={theme.weekLabel} fontSize={1}>
                                    {week}
                                </Text>
                                <Flex className={theme.daysWrap}>
                                    <HolidayWeek
                                        weekInfo={this.getCurrentWeekInfo(week)}
                                        toggleDay={this.toggleDay}
                                        week={week}
                                        t={t}
                                    />
                                </Flex>
                            </Flex>
                        );
                    })}
                </Flex>
            );
        }
        return null;
    }
}
